import * as React from "react";
import type { SVGProps } from "react";
const SvgTicketVertical = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4 5a3 3 0 0 1 3-3h3a1 1 0 0 1 1 .995V3a2.774 2.774 0 0 0 .022.257c.025.183.072.409.156.62.086.214.191.368.306.463.097.08.244.159.516.159s.42-.078.516-.159c.115-.095.22-.249.306-.462a2.65 2.65 0 0 0 .176-.829L13 3.001v-.006A1 1 0 0 1 14 2h3a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V5Zm10.873-1a4.366 4.366 0 0 1-.194.621c-.165.412-.435.883-.883 1.257-.465.388-1.068.622-1.796.622s-1.33-.234-1.796-.622c-.448-.374-.718-.845-.882-1.257A4.353 4.353 0 0 1 9.127 4H7a1 1 0 0 0-1 1v5h2a1 1 0 1 1 0 2H6v7a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-7h-2a1 1 0 1 1 0-2h2V5a1 1 0 0 0-1-1h-2.127ZM10 11a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTicketVertical;
